import ReviewCardsReviewsComponent from "./review-cards-reviews-component";
import ReviewCardsReviewsConfig from "./review-cards-reviews-config";
import ReviewCardsReviewsAdvancedConfig from "./review-cards-reviews-advanced-config";

export default {
  ReviewCardsReviewsComponent,
  ReviewCardsReviewsConfig,
  ReviewCardsReviewsAdvancedConfig
};
